import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { classNameTriskeleParser } from '../../utilities/customStyles';
import { Body2400C } from '../../utilities/generatedClasses';
import { overlayTopSide, unOverlayTopSide } from '../../utilities/utils';
import { setDrawer } from '../../redux/actions/drawerActions';

const LogoContainer = (props) => {
  const { title } = props;

  const dispatch = useDispatch();
  const drawerAction = useSelector(state => state.drawer);

  const opencloseDrawer = () => {
    if (drawerAction === false) {
      overlayTopSide();
      dispatch(setDrawer(true));
    } else {
      unOverlayTopSide();
      dispatch(setDrawer(false));
    }
  };

  return (
    <div
      className="logo"
      style={{
        width: '100%', display: 'flex', alignItems: 'center', background: '#FAFAFA'
      }}>
      <div className="logo-container" aria-hidden onClick={() => opencloseDrawer()}>
        <div className={`logo-img ${classNameTriskeleParser('Prism Logo', 'Default', 'Image')}`} />
      </div>
      <label className={Body2400C}>{title}</label>
    </div>
  );
};

export default LogoContainer;
